<div class="flex justify-content-center p-3">
  <div class="w-full max-w-4xl">
    <p-card>
      <ng-template pTemplate="header">
        <div class="text-center py-3">
          <img src="assets/img/homelogo.png" alt="Circle Cart" class="mb-2" style="max-height: 60px; width: auto;">
          <h1 class="text-2xl font-bold m-0">{{ 'i18n.domain.privacy-policy.title' | translate }}</h1>
        </div>
      </ng-template>
      
      <div *ngIf="privacyPolicy">
        <div class="mb-3 p-2 surface-100 border-left-3 border-primary">
          <div class="text-sm text-600 mb-1">
            <strong>{{ 'i18n.domain.privacy-policy.version' | translate }}:</strong> {{ privacyPolicy.version }}
          </div>
          <div *ngIf="privacyPolicy.modifiedOn" class="text-sm text-600">
            <strong>{{ 'i18n.domain.privacy-policy.last-updated' | translate }}:</strong> 
            {{ privacyPolicy.modifiedOn?.toJSDate() | date:'longDate' }}
          </div>
        </div>
        
        <p-divider class="my-3"></p-divider>
        
        <div [innerHTML]="privacyPolicy.policyContent" class="line-height-3 text-justify"></div>
      </div>

      
      <ng-template pTemplate="footer">
        <div class="text-center" style="background: #1f2937; color: white; padding: 1rem; margin: -1rem -1rem -1rem -1rem;">
          <p class="m-0">
            &copy; {{ currentYear }} 
            <a href="https://techietechit.com/" target="_blank" style="color: #d1d5db; text-decoration: none;">
              TechieTech IT Services LLP.
            </a>All rights reserved.
          </p>
        </div>
      </ng-template>
    </p-card>
  </div>
</div>